// Dependencies
require("webstrap/type");
require("webstrap/forms");
require("webstrap/buttons");
require("mailchimp-ajax");

// Styles
require("./popup.scss");

// JavaScript
var $ = require("jquery");
var cookiesUtils = require("cookies-utils");
var localcookie = cookiesUtils.read('localecookie');

// Each popup (should be 1)
$('.sec-popup').each(function () {

    var $popup = $(this);

    // Créer cookie
    function CreateCookie() {
        cookiesUtils.create($popup.data("cookie-name"), "1", 2);
    };

    // Fermeture du popup
    function ClosePopup() {
        $popup.removeClass("sec-popup--open");
        CreateCookie();
    };

    // Form mailchimp
    var $formId = $("#popop-mc-embedded-subscribe-form", $popup);

    // Form validation (setup for manual validation)
    require("forms-validation");
    $formId.validate(require("forms-validation/options/defaults.js"));

    // Ouverture après 15sec
    setTimeout(function () {
        $popup.addClass("sec-popup--open");
    }, 15000); // 15 sec = 15000

    // Bouton de fermeture
    $('.sec-popup__close, .sec-popup__no-thx', $popup).on("click", ClosePopup);

    // Créer le cookie si l'usagé suit un lien
    $('a', $popup).on("click", CreateCookie);

});





/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/popup/index.js
 ** module id = 71
 ** module chunks = 0 1
 **/